var _polygon, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDelimiterHeader = function SvgDelimiterHeader(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "22px",
    viewBox: "0 0 16 22",
    enableBackground: "new 0 0 16 22",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 16,0 2.292,22 0,22 ",
    className: "delimiter-bg"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "delimiter-right",
    points: "16,0 15.158,0 0.026,25.708 16,25.708  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "delimiter-left",
    points: "0.917,0 -10,0 -10,20 0.917,20 12.706,0  "
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelimiterHeader, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMjJweCIgdmlld0JveD0iMCAwIDE2IDIyIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAxNiAyMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8cG9seWdvbiBwb2ludHM9IjAsMCAxNiwwIDIuMjkyLDIyIDAsMjIgIiBjbGFzcz0iZGVsaW1pdGVyLWJnIi8+DQo8Zz4NCgk8cG9seWxpbmUgY2xhc3M9ImRlbGltaXRlci1yaWdodCIgcG9pbnRzPSIxNiwwIDE1LjE1OCwwIDAuMDI2LDI1LjcwOCAxNiwyNS43MDggCSIvPg0KCTxwb2x5Z29uIGNsYXNzPSJkZWxpbWl0ZXItbGVmdCIgcG9pbnRzPSIwLjkxNywwIC0xMCwwIC0xMCwyMCAwLjkxNywyMCAxMi43MDYsMCAJIi8+DQo8L2c+DQo8L3N2Zz4NCg==";
export { ForwardRef as ReactComponent };